import * as Haptics from 'expo-haptics';

/**
 * Vibración de confirmación que NUNCA puede tumbar la operación que la llama.
 *
 * EL FALLO QUE ESTO CIERRA — EL "ERROR" FANTASMA DE LA LLEGADA
 *
 * Por toda la app había esta forma, DENTRO de bloques `try` y justo después
 * del `await` que hacía el trabajo de verdad:
 *
 *     Haptics.notificationAsync?.(Haptics.NotificationFeedbackType?.Success).catch?.(() => {})
 *
 * El `?.` protege la llamada, pero si `notificationAsync` no está enlazada,
 * la expresión devuelve `undefined` y leer `.catch` de `undefined` lanza un
 * **TypeError**. Como estaba dentro del mismo `try`, ese TypeError caía en el
 * `catch` del negocio y el chofer veía:
 *
 *     "No pudimos avisar tu llegada. Intenta de nuevo."
 *
 * ...aunque el estado ARRIVED se había guardado perfectamente en Firestore.
 * Por eso la pantalla del PIN aparecía igual: el aviso SÍ había llegado; lo
 * único roto era la vibración.
 *
 * Aquí no se escapa nada: ni excepción síncrona, ni promesa rechazada.
 */
export function vibrarExito(): void {
  try {
    const r: any = (Haptics as any)?.notificationAsync?.(
      (Haptics as any)?.NotificationFeedbackType?.Success
    );
    if (r && typeof r.catch === 'function') r.catch(() => {});
  } catch {
    // La vibración es un adorno. Que falle no puede afectar a nada.
  }
}

/** Vibración de error, con la misma garantía. */
export function vibrarError(): void {
  try {
    const r: any = (Haptics as any)?.notificationAsync?.(
      (Haptics as any)?.NotificationFeedbackType?.Error
    );
    if (r && typeof r.catch === 'function') r.catch(() => {});
  } catch {
    /* no-op */
  }
}
